export default __webpack_public_path__ + "static/media/download-dark.6ff5aa82.svg";